// extracted by mini-css-extract-plugin
export default {"modalOverlay":"SD-z","modalContent":"TD-z","header":"UD-z","close":"VD-z"};